// plop_marker:layouts_import
import DynamicDevlink from "./dynamic-devlink/index.js";
export default {
    // plop_marker:layouts_add_layout
    DynamicDevlink
};
